(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7555],{

/***/ 11752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(36616)


/***/ }),

/***/ 72650:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(25877);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(27603));

var _interweave = __webpack_require__(59996);

var _jsxRuntime = __webpack_require__(85893);

var ContractTextContainer = _styledComponents.default.div.withConfig({
  displayName: "ContractTextContainer",
  componentId: "sc-7rbo6k-0"
})(["font-size:1rem;text-align:justify;word-wrap:break-word;"]);

var ContractText = function ContractText(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ContractTextContainer, {
    id: "terms-and-conditions-phrase",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_interweave.Interweave, {
      content: content
    })
  });
};

var _default = ContractText;
exports["default"] = _default;

/***/ }),

/***/ 75964:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(25877);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(87794));

__webpack_require__(41539);

__webpack_require__(39714);

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(49376));

var _styledComponents = _interopRequireDefault(__webpack_require__(27603));

var _head = _interopRequireDefault(__webpack_require__(9008));

var _consents = __webpack_require__(45105);

var _ContractText = _interopRequireDefault(__webpack_require__(72650));

var _CONTRACTS = _interopRequireDefault(__webpack_require__(37747));

var _store = __webpack_require__(26638);

var _analytics = __webpack_require__(87090);

var _jsxRuntime = __webpack_require__(85893);

var TermsTextContainer = _styledComponents.default.div.withConfig({
  displayName: "TermsTextContainer",
  componentId: "sc-19wkckm-0"
})(["margin:2vh 2vw;"]);

var Terms = function Terms(_ref) {
  var termsContent = _ref.termsContent,
      candidateId = _ref.candidateId;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_head.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
        id: "gtag-function-script",
        async: true,
        dangerouslySetInnerHTML: {
          __html: (0, _analytics.gtagScript)(candidateId)
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TermsTextContainer, {
      id: "terms-and-conditions-phrase",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContractText.default, {
        content: termsContent
      })
    })]
  });
};

Terms.getInitialProps = _store.wrapper.getInitialPageProps(function () {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_index.default.mark(function _callee(_ref2) {
      var req, candidate, candidateId, termsData;
      return _index.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              req = _ref2.req;
              candidate = req.candidate;
              candidateId = candidate ? candidate.id : '0';
              _context.next = 5;
              return (0, _consents.getContract)({
                candidateId: candidateId,
                version: req.query.version && req.query.version.toString(),
                contractType: _CONTRACTS.default.TERMS_AND_CONDITIONS,
                transactionId: req.transactionId
              });

            case 5:
              termsData = _context.sent;
              return _context.abrupt("return", {
                termsContent: termsData && termsData.content ? termsData.content : '',
                candidateId: candidateId
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
});
var _default = Terms; // @refresh reset

exports["default"] = _default;

/***/ }),

/***/ 87090:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(25877);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.gtagScript = void 0;

__webpack_require__(92222);

var _config = _interopRequireDefault(__webpack_require__(11752));

var _getConfig = (0, _config.default)(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var gtagScript = function gtagScript(userId) {
  return "\n  window.dataLayer = window.dataLayer || [];\n  function gtag(){dataLayer.push(arguments);}\n  gtag('js', new Date());\n  gtag('config', '".concat(publicRuntimeConfig.GTAG_ID, "', {\n    'user_id': '").concat(userId, "',\n    'user_properties': {\n      'id_catho': '").concat(userId, "'\n    }\n  });\n");
};

exports.gtagScript = gtagScript;

/***/ }),

/***/ 45105:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(25877);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.hasAcceptedTermVersion = exports.hasAcceptedContractVersion = exports.getTerms = exports.getContract = exports.acceptTerms = exports.acceptContract = void 0;

__webpack_require__(92222);

var _nodeCache = _interopRequireDefault(__webpack_require__(70321));

var _http = _interopRequireDefault(__webpack_require__(20687));

var _APIS = _interopRequireDefault(__webpack_require__(32668));

var _throwTypedError = _interopRequireDefault(__webpack_require__(97165));

var _loggers = __webpack_require__(82609);

var _SERVICE_ERROR_TYPES = _interopRequireDefault(__webpack_require__(52400));

var consentCache = new _nodeCache.default();

var consentCacheKey = function consentCacheKey(contractType, version) {
  return "consent_contract_".concat(contractType, "_").concat(version);
};

var getTerms = function getTerms(_ref) {
  var candidateId = _ref.candidateId,
      transactionId = _ref.transactionId,
      contractType = _ref.contractType,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? 'latest' : _ref$version;
  var message;
  var requestOpts = {
    method: 'get',
    url: _APIS.default.CONSENTS.TERMS_AND_CONDITIONS_URL(contractType, version),
    headers: {
      'x-api-key': _APIS.default.CONSENTS.API_KEY,
      'x-transaction-id': transactionId
    }
  };
  var consentData = consentCache.get(consentCacheKey(contractType, version));

  if (consentData && consentData.content) {
    return consentData;
  }

  return (0, _http.default)(requestOpts).catch(function (error) {
    message = "Failed to fetch consent term: ".concat(error.message);

    _loggers.requestLogger.error({
      message: message,
      candidateId: candidateId,
      transactionId: error.transactionId
    });

    (0, _throwTypedError.default)(message, _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
  }).then(function (res) {
    if (res.status !== 200) {
      message = "Failed to fetch consent term, received status ".concat(res.status, ": ").concat(JSON.stringify(res.data));

      _loggers.requestLogger.error({
        message: message,
        statusCode: res.status,
        candidateId: candidateId,
        transactionId: res.transactionId
      });

      (0, _throwTypedError.default)(message, res.status === 401 || res.status === 404 ? _SERVICE_ERROR_TYPES.default.NOT_FOUND : _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
      return null;
    }

    res.data.id = _APIS.default.CONSENTS.TERM_UUID(contractType);
    consentCache.set(consentCacheKey(contractType, version), res.data, 3600);
    return res.data;
  });
};

exports.getTerms = getTerms;

var getContract = function getContract(_ref2) {
  var candidateId = _ref2.candidateId,
      _ref2$transactionId = _ref2.transactionId,
      transactionId = _ref2$transactionId === void 0 ? '' : _ref2$transactionId,
      contractType = _ref2.contractType,
      _ref2$version = _ref2.version,
      version = _ref2$version === void 0 ? 'latest' : _ref2$version;
  var message;
  var requestOpts = {
    method: 'get',
    url: _APIS.default.CONSENTS.CONTRACT_URL(contractType, version),
    headers: {
      'x-api-key': _APIS.default.CONSENTS.API_KEY,
      'x-transaction-id': transactionId
    }
  };
  var consentData = consentCache.get(consentCacheKey(contractType, version));

  if (consentData && consentData.content) {
    return consentData;
  }

  return (0, _http.default)(requestOpts).catch(function (error) {
    message = "Failed to fetch contract: ".concat(error.message);

    _loggers.requestLogger.error({
      message: message,
      candidateId: candidateId,
      transactionId: error.transactionId
    });

    (0, _throwTypedError.default)(message, _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
  }).then(function (res) {
    if (res.status !== 200) {
      message = "Failed to fetch contract, received status ".concat(res.status, ": ").concat(JSON.stringify(res.data));

      _loggers.requestLogger.error({
        message: message,
        statusCode: res.status,
        candidateId: candidateId,
        transactionId: res.transactionId
      });

      (0, _throwTypedError.default)(message, res.status === 401 || res.status === 404 ? _SERVICE_ERROR_TYPES.default.NOT_FOUND : _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
      return null;
    }

    res.data.id = _APIS.default.CONSENTS.CONTRACT_UUID(contractType);
    consentCache.set(consentCacheKey(contractType, version), res.data, 3600);
    return res.data;
  });
};

exports.getContract = getContract;

var acceptTerms = function acceptTerms(_ref3) {
  var candidateId = _ref3.candidateId,
      sessionToken = _ref3.sessionToken,
      termId = _ref3.termId,
      termVersion = _ref3.termVersion,
      transactionId = _ref3.transactionId;
  var message;
  var requestOpts = {
    method: 'post',
    url: _APIS.default.CONSENTS.ACCEPT_URL,
    data: {
      termId: termId,
      termVersion: termVersion,
      action: 'consenting'
    },
    headers: {
      Authorization: "Bearer ".concat(sessionToken),
      'x-api-key': _APIS.default.CONSENTS.API_KEY,
      'x-transaction-id': transactionId
    }
  };
  return (0, _http.default)(requestOpts).catch(function (error) {
    message = "Failed to accept consent term: ".concat(error.message);

    _loggers.requestLogger.error({
      message: message,
      candidateId: candidateId,
      transactionId: error.transactionId || transactionId
    });

    (0, _throwTypedError.default)(message, _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
  }).then(function (res) {
    if (!(res.status >= 200 && res.status < 300)) {
      message = "Failed to accept consent term ".concat(termId, "__").concat(termVersion, ", received status ").concat(res.status, ": ").concat(JSON.stringify(res.data));

      _loggers.requestLogger.error({
        message: message,
        statusCode: res.status,
        candidateId: candidateId,
        transactionId: res.transactionId || transactionId
      });

      (0, _throwTypedError.default)(message, res.status === 401 || res.status === 404 ? _SERVICE_ERROR_TYPES.default.NOT_FOUND : _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
      return null;
    }

    return res.data;
  });
};

exports.acceptTerms = acceptTerms;

var acceptContract = function acceptContract(_ref4) {
  var candidateId = _ref4.candidateId,
      sessionToken = _ref4.sessionToken,
      termId = _ref4.termId,
      termVersion = _ref4.termVersion,
      transactionId = _ref4.transactionId;
  var message;
  var requestOpts = {
    method: 'post',
    url: _APIS.default.CONSENTS.ACCEPT_URL,
    data: {
      termId: termId,
      termVersion: termVersion,
      action: 'consenting'
    },
    headers: {
      Authorization: "Bearer ".concat(sessionToken),
      'x-api-key': _APIS.default.CONSENTS.API_KEY,
      'x-transaction-id': transactionId
    }
  };
  return (0, _http.default)(requestOpts).catch(function (error) {
    message = "Failed to accept contract: ".concat(error.message);

    _loggers.requestLogger.error({
      message: message,
      candidateId: candidateId,
      transactionId: error.transactionId || transactionId
    });

    (0, _throwTypedError.default)(message, _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
  }).then(function (res) {
    if (!(res.status >= 200 && res.status < 300)) {
      message = "Failed to accept contract, received status ".concat(res.status, ": ").concat(JSON.stringify(res.data));

      _loggers.requestLogger.error({
        message: message,
        statusCode: res.status,
        candidateId: candidateId,
        transactionId: res.transactionId || transactionId
      });

      (0, _throwTypedError.default)(message, res.status === 404 ? _SERVICE_ERROR_TYPES.default.NOT_FOUND : _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
      return null;
    }

    return res.data;
  });
};

exports.acceptContract = acceptContract;

var hasAcceptedTermVersion = function hasAcceptedTermVersion(_ref5) {
  var candidateId = _ref5.candidateId,
      sessionToken = _ref5.sessionToken,
      transactionId = _ref5.transactionId,
      termVersion = _ref5.termVersion,
      contractType = _ref5.contractType;
  var message;
  var requestOpts = {
    method: 'get',
    url: _APIS.default.CONSENTS.VERSION_URL(contractType, termVersion),
    headers: {
      Authorization: "Bearer ".concat(sessionToken),
      'x-api-key': _APIS.default.CONSENTS.API_KEY,
      'x-transaction-id': transactionId
    }
  };
  return (0, _http.default)(requestOpts).catch(function (error) {
    message = "Failed to fetch term version: ".concat(error.message);

    _loggers.requestLogger.error({
      message: message,
      candidateId: candidateId,
      transactionId: error.transactionId
    });

    (0, _throwTypedError.default)(message, _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
  }).then(function (res) {
    if (res.status !== 200) {
      message = "Failed to fetch term version ".concat(contractType, "__").concat(termVersion, ", received status ").concat(res.status, ": ").concat(JSON.stringify(res.data));

      _loggers.requestLogger.error({
        message: message,
        statusCode: res.status,
        candidateId: candidateId,
        transactionId: res.transactionId
      });

      return false;
    }

    return res.data[0].termVersion === termVersion && res.data[0].hasAccepted;
  });
};

exports.hasAcceptedTermVersion = hasAcceptedTermVersion;

var hasAcceptedContractVersion = function hasAcceptedContractVersion(_ref6) {
  var candidateId = _ref6.candidateId,
      sessionToken = _ref6.sessionToken,
      transactionId = _ref6.transactionId,
      contractVersion = _ref6.contractVersion,
      contractType = _ref6.contractType;
  var message;
  var requestOpts = {
    method: 'get',
    url: _APIS.default.CONSENTS.VERSION_URL(contractType, contractVersion),
    headers: {
      Authorization: "Bearer ".concat(sessionToken),
      'x-api-key': _APIS.default.CONSENTS.API_KEY,
      'x-transaction-id': transactionId
    }
  };
  return (0, _http.default)(requestOpts).catch(function (error) {
    message = "Failed to fetch contract version: ".concat(error.message);

    _loggers.requestLogger.error({
      message: message,
      candidateId: candidateId,
      transactionId: error.transactionId
    });

    (0, _throwTypedError.default)(message, _SERVICE_ERROR_TYPES.default.FETCH_FAILURE);
  }).then(function (res) {
    if (res.status !== 200) {
      message = "Failed to fetch contract version, received status ".concat(res.status, ": ").concat(JSON.stringify(res.data));

      _loggers.requestLogger.error({
        message: message,
        statusCode: res.status,
        candidateId: candidateId,
        transactionId: res.transactionId
      });

      return false;
    }

    return res.data[0].termVersion === contractVersion && res.data[0].hasAccepted;
  });
};

exports.hasAcceptedContractVersion = hasAcceptedContractVersion;

/***/ }),

/***/ 31388:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termos-de-uso",
      function () {
        return __webpack_require__(75964);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7603,8297,509,6700,9774,2888,179], function() { return __webpack_exec__(31388); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);